<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Listado de Cargas de Combustible</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-select item-color="green" color="green darken-2" dense v-model="filtrocodgral"
                                :items="listadoequipo" label="Equipo" item-text="nombre"
                                item-value="codgral"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <!-- <v-text-field label="Filtro por Mes / Año" dense v-model="filtromes">
                            </v-text-field>
                        </v-col>
                        <v-col> -->
                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                :return-value.sync="filtromes" transition="scale-transition" offset-y max-width="290px"
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field clearable dense v-model="filtromes" label="Año - Mes"
                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker dense locale="es-ar" v-model="filtromes" type="month"
                                    color="green lighten-1" no-title scrollable @input="$refs.menu.save(filtromes)">
                                    <!-- <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">
                                        Cancel
                                    </v-btn>
                                    <v-btn text color="primary" @click="$refs.menu.save(date)">
                                        OK
                                    </v-btn> -->
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Filtro por Responsable" dense v-model="filtroresponsable">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Filtro por Imputación" dense v-model="filtroobserv">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListados()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" group-by="nombre" locale="es-ar" class="elevation-1"
                :items-per-page="200" :footer-props="{
                itemsPerPageText: 'equipos por página',
            }">
                <template v-slot:group.header="{ items }">
                    <td class="text-xs-right">
                        <strong>{{ items[0].nombre }}</strong>
                    </td>
                </template>
                <template v-slot:group.summary="{ group, items }">
                    <th></th>
                    <th></th>
                    <th>
                    <td>
                        {{ subTotal(items, 'litros').toFixed(2) }}
                    </td>
                    </th>
                    <th></th>
                    <td>
                        {{ subTotal(items, 'importe').toFixed(2) }}
                    </td>
                </template>
            </v-data-table>
        </v-app>
    </div>
</template>

<script>
import axios from "../../../axios-auth";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {

    data: (vm) => ({

        filtrocodgral: "",
        filtromes: "",
        filtroresponsable: "",
        filtroobserv: "",
        listadoequipo: [],
        date: new Date().toISOString().substr(0, 7),
        datehoy: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        listado: [],


        headers: [
            {
                text: "Vehículo",
                align: "start",
                sortable: false,
                value: "nombre",
                width: "20%"
            },
            { text: "", value: "", width: "7%" },
            { text: "Kilometraje", value: "km", width: "7%" },
            { text: "Litros", value: "litros", width: "6%" },
            { text: "Fecha", value: "fecha", width: "8%" },
            { text: "Importe", value: "importe", width: "7%" },
            { text: "N° Ticket", value: "ticket", width: "7%" },
            { text: "N° Factura", value: "comprobante", width: "7%" },
            { text: "Cuit", value: "cuit", width: "10%" },
            { text: "Responsable", value: "responsable", width: "13%" },
            { text: "Observaciones", value: "observ", width: "15%" },

        ],
    }),

    computed: {
        show: {
            get() {
                this.cargarEquipo();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        subTotal(items, column) {
            console.warn(items, column);
            //return items.reduce((sum, item) => sum + item[column], 0);
            return items.reduce((sum, item) => sum + parseFloat(item[column].toString().replace(',', '.')), 0);
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month] = date.split("-");
            return `${month}/${year}`;
        },
        cargarEquipo() {
            let self = this;
            axios
                .get("/SSGG/CargarVehiculo?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.listadoequipo = response.data;
                })
                .catch((error) => {
                    self.listadoequipo = "";
                    console.log(error);
                });
        },
        cargarListados() {
            this.vaciarModels();

            if (this.filtromes == null) {
                this.filtromes = "";
            }
            if (this.filtrocodgral == null) {
                this.filtrocodgral = "";
            }
            if (this.filtroresponsable == null) {
                this.filtroresponsable = "";
            }
            if (this.filtroobserv == null) {
                this.filtroobserv = "";
            }
            const mes = this.filtromes.substring(5, 7) + "/" + this.filtromes.substring(0, 4);
            const responsable = this.filtroresponsable;
            const codgral = this.filtrocodgral;
            const observ = this.filtroobserv;
            console.log("1" + codgral)
            console.log("1" + responsable)
            console.log("1" + mes)
            console.log("1" + observ)


            let self = this;

            axios
                .get("/SSGG/ListadoCombustible?", {
                    params: {

                        filtrocodgral: codgral,
                        filtroresponsable: responsable,
                        filtromes: mes,
                        filtroobserv: observ,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>